"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends")),
    _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray")),
    _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
    _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
    _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
    _react = _interopRequireWildcard(require("react")),
    _lodash = _interopRequireDefault(require("lodash.memoize")),
    _classnames = _interopRequireDefault(require("classnames")),
    _uiKit = require("@devsta/ui-kit");

require("./styles/_changes_modal.scss");

function ownKeys(a, b) {
  var c = Object.keys(a);

  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }

  return c;
}

function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) {
    b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
      (0, _defineProperty2["default"])(a, c, b[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
      Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
    });
  }

  return a;
}

function _createSuper(a) {
  var b = _isNativeReflectConstruct();

  return function () {
    var c,
        d = (0, _getPrototypeOf2["default"])(a);

    if (b) {
      var e = (0, _getPrototypeOf2["default"])(this).constructor;
      c = Reflect.construct(d, arguments, e);
    } else c = d.apply(this, arguments);

    return (0, _possibleConstructorReturn2["default"])(this, c);
  };
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (a) {
    return !1;
  }
}

var OTHER_REASON = "Other",
    INITIAL_STATE = {
  selectedReasons: [],
  otherReason: ""
},
    ChangesModal = function (a) {
  function b() {
    var a, d;
    (0, _classCallCheck2["default"])(this, b);

    for (var e = arguments.length, f = Array(e), g = 0; g < e; g++) {
      f[g] = arguments[g];
    }

    return (0, _possibleConstructorReturn2["default"])(d, (a = d = c.call.apply(c, [this].concat(f)), d.state = INITIAL_STATE, d.onCheck = (0, _lodash["default"])(function (a) {
      return function () {
        var b = d.props.multiple,
            c = d.state.selectedReasons;

        if (b) {
          var e = c.includes(a) ? c.filter(function (b) {
            return b !== a;
          }) : [].concat((0, _toConsumableArray2["default"])(c), [a]);
          return void d.setState(_objectSpread({
            selectedReasons: e
          }, a === OTHER_REASON ? {
            otherReason: ""
          } : {}));
        }

        d.setState(_objectSpread({
          selectedReasons: [a]
        }, a === OTHER_REASON ? {} : {
          otherReason: ""
        }));
      };
    }), d.resetState = function () {
      d.setState(INITIAL_STATE);
    }, d.onInputChange = function (a) {
      var b = a.target.value;
      d.setState({
        otherReason: b
      });
    }, d.getSelectedReasons = function () {
      var a = d.state,
          b = a.selectedReasons,
          c = a.otherReason;
      return [].concat((0, _toConsumableArray2["default"])(b), (0, _toConsumableArray2["default"])(b.includes(OTHER_REASON) ? [c] : [])).filter(function (a) {
        return !!a && a !== OTHER_REASON;
      });
    }, d.onSave = function () {
      var a = d.props,
          b = a.onSave,
          c = a.multiple,
          e = d.getSelectedReasons(),
          f = c ? e : e[0];
      b(f);
    }, a));
  }

  (0, _inherits2["default"])(b, a);

  var c = _createSuper(b);

  return (0, _createClass2["default"])(b, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(a) {
      var b = a.visible,
          c = this.props.visible;
      c || !b || this.resetState();
    }
  }, {
    key: "render",
    value: function render() {
      var a = this,
          b = this.props,
          c = b.visible,
          d = b.saveText,
          e = b.stayOpen,
          f = b.onClose,
          g = b.reasons,
          h = b.title,
          i = b.subtitle,
          j = b.additionalReasonTitle,
          k = b.columns,
          l = b.multiple,
          m = b.allowOther,
          n = this.state,
          o = n.otherReason,
          p = n.selectedReasons,
          q = m ? [].concat((0, _toConsumableArray2["default"])(g), [OTHER_REASON]) : g,
          r = l ? _uiKit.Checkbox : _uiKit.RadioButton,
          s = l ? "checked" : "selected",
          t = this.getSelectedReasons();
      return _react["default"].createElement(_uiKit.FormModal, {
        visible: c,
        onClose: f,
        title: h,
        subtitle: i,
        saveText: d,
        onSave: this.onSave,
        stayOpenOnSave: e,
        saveDisabled: !t.length
      }, _react["default"].createElement("ul", {
        className: (0, _classnames["default"])("changes-modal__reasons", {
          "changes-modal__reasons__columns": k
        })
      }, q.map(function (b) {
        return _react["default"].createElement("li", {
          key: b,
          className: "changes-modal__reasons__item"
        }, _react["default"].createElement(r, (0, _extends2["default"])({
          key: b
        }, (0, _defineProperty2["default"])({}, s, p.includes(b)), {
          onChange: a.onCheck(b)
        }), b));
      })), m && p.includes(OTHER_REASON) && _react["default"].createElement(_uiKit.Input, {
        className: "changes-modal__additional-reason",
        label: j,
        value: o,
        onChange: this.onInputChange,
        rows: 4,
        multiline: !0,
        labelProps: {
          required: !0
        }
      }));
    }
  }]), b;
}(_react.Component);

ChangesModal.defaultProps = {
  additionalReasonTitle: "Reasons"
};
var _default = ChangesModal;
exports["default"] = _default;